import { BackOfficeAPIApiFactory } from '@api/swagger/definitions/backoffice'
import type { BureauFeatures } from '@domains/bureau/priv/api/api'
import { BureauApiFactory } from '@mynt/backoffice-api-spec/bureau'
import Axios from 'api/axios'
import config from 'config'
import { mapBureauConfigToBureauFeatures, mapBureauFeaturesToBureauConfig, mapBureauRelationshipResponseToBureauParent } from './mappers'

const backofficeApi = BackOfficeAPIApiFactory(undefined, config.boBaseUrl, Axios)
const bureauApi = BureauApiFactory(undefined, config.boBaseUrl, Axios)

export const getBureauParent = (customerId: string) =>
  backofficeApi
    .client(customerId, { disableCustomErrorHandler: true })
    .then(({ data }) => mapBureauRelationshipResponseToBureauParent(data))

export const getBureauFeatures = (customerId: string) =>
  bureauApi.getBureauConfig(customerId).then(({ data }) => mapBureauConfigToBureauFeatures(data))

export const updateBureauFeatures = (customerId: string, features: BureauFeatures) =>
  bureauApi.updateBureauConfig(customerId, mapBureauFeaturesToBureauConfig(features))
